import { toQueryString, addMinutesToDateTime } from "./Helper";



//B2C

function callApiWithAccessToken(endpoint, token) {
    const headers = new Headers();
    const bearer = `Bearer ${token}`;
    const Logger = new Logger();
    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    fetch(endpoint, options)
        .then(response => response.json())
        .then(response => {
            Logger.logMessage("Web API returned:\n" + JSON.stringify(response));
        }).catch(error => {
            Logger.logMessage("Error calling the Web api:\n" + error);
        });
}

export const initializeUser = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = window.env.api.baseUrl + window.env.api.initializeUser;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'none',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

//End B2C

//Public Operations

export const getLinkedAccounts = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.linkedAccounts}`;
            const response = await fetch(url, {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const addLinkedAccount = (accountId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.linkedAccounts}/${accountId}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const removeLinkedAccount = (accountId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.linkedAccounts}/${accountId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

//CRUD Operations

//Account
export const getAccounts = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accounts}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getAccount = (accountId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accounts}/${accountId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                resolve(null);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveAccount = (account) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accounts}/${account.accountID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(account) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addAccount = (account) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = window.env.api.baseUrl + window.env.api.accounts;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(account) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteAccount = (accountId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accounts}/${accountId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Fees
export const getFees = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                const fees = result.map(fee => {
                    fee.dueDate = new Date(fee.dueDate);
                    addMinutesToDateTime(fee.dueDate, -fee.dueDate.getTimezoneOffset()); //Adjusting for timezone
                    return fee;
                });
                resolve(fees);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getFee = (feeId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}/${feeId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const fee = await response.json();
                fee.dueDate = new Date(fee.dueDate);
                addMinutesToDateTime(fee.dueDate, -fee.dueDate.getTimezoneOffset()); //Adjusting for timezone
                resolve(fee);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveFee = (fee) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}/${fee.feeID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(fee) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addFee = (fee) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(fee) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteFee = (feeId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}/${feeId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Payments
export const getPayments = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.payments}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                const payments = result.map(payment => {
                    payment.paidDate = new Date(payment.paidDate);
                    addMinutesToDateTime(payment.paidDate, -payment.paidDate.getTimezoneOffset()); //Adjusting for timezone
                    return payment;
                });
                resolve(payments);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getPayment = (paymentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.payments}/${paymentId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const payment = await response.json();
                payment.paidDate = new Date(payment.paidDate);
                addMinutesToDateTime(payment.paidDate, -payment.paidDate.getTimezoneOffset()); //Adjusting for timezone
                resolve(payment);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const savePayment = (payment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.payments}/${payment.paymentID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(payment) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addPayment = (payment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.payments}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(payment) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deletePayment = (paymentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.payments}/${paymentId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Users
export const getUsers = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.users}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getUser = (userId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.users}/${userId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const user = await response.json();
                resolve(user);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveUser = (user) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.users}/${user.userID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(user) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addUser = (user) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.users}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(user) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteUser = (userId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.users}/${userId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Roles
export const getRoles = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.roles}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getRole = (roleId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.roles}/${roleId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const role = await response.json();
                resolve(role);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveRole = (role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.roles}/${role.roleID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(role) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addRole = (role) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.roles}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(role) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteRole = (roleId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.roles}/${roleId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//AccountComments
export const getAccountComments = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountComments}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                const accountComments = result.map(accountComment => {
                    accountComment.commentDate = new Date(accountComment.commentDate);
                    addMinutesToDateTime(accountComment.commentDate, -accountComment.commentDate.getTimezoneOffset()); //Adjusting for timezone
                    return accountComment;
                });
                resolve(accountComments);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getAccountComment = (accountCommentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountComments}/${accountCommentId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const accountComment = await response.json();
                accountComment.commentDate = new Date(accountComment.commentDate);
                addMinutesToDateTime(accountComment.commentDate, -accountComment.commentDate.getTimezoneOffset()); //Adjusting for timezone
                resolve(accountComment);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveAccountComment = (accountComment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountComments}/${accountComment.accountCommentID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountComment) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addAccountComment = (accountComment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountComments}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountComment) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteAccountComment = (accountCommentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountComments}/${accountCommentId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//FeeComments
export const getFeeComments = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.feeComments}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                const feeComments = result.map(feeComment => {
                    feeComment.commentDate = new Date(feeComment.commentDate);
                    addMinutesToDateTime(feeComment.commentDate, -feeComment.commentDate.getTimezoneOffset()); //Adjusting for timezone
                    return feeComment;
                });
                resolve(feeComments);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getFeeComment = (feeCommentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.feeComments}/${feeCommentId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const feeComment = await response.json();
                feeComment.commentDate = new Date(feeComment.commentDate);
                addMinutesToDateTime(feeComment.commentDate, -feeComment.commentDate.getTimezoneOffset()); //Adjusting for timezone
                resolve(feeComment);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveFeeComment = (feeComment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.feeComments}/${feeComment.feeCommentID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(feeComment) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addFeeComment = (feeComment) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.feeComments}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(feeComment) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteFeeComment = (feeCommentId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.feeComments}/${feeCommentId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//PaymentTypes
export const getPaymentTypes = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.paymentTypes}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getPaymentType = (paymentTypeId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.paymentTypes}/${paymentTypeId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const paymentType = await response.json();
                resolve(paymentType);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const savePaymentType = (paymentType) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.paymentTypes}/${paymentType.paymentTypeID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(paymentType) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addPaymentType = (paymentType) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.paymentTypes}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(paymentType) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deletePaymentType = (paymentTypeId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.paymentTypes}/${paymentTypeId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Preferences
export const getPreferences = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.preferences}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getPreference = (preferenceId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.preferences}/${preferenceId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const preference = await response.json();
                resolve(preference);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const savePreference = (preference) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.preferences}/${preference.preferenceID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(preference) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addPreference = (preference) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.preferences}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(preference) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deletePreference = (preferenceId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.preferences}/${preferenceId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//AccountPreferences
export const getAccountPreferences = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountPreferences}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getAccountPreference = (accountId, preferenceId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountPreferences}/${accountId}/${preferenceId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const accountPreference = await response.json();
                resolve(accountPreference);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveAccountPreference = (accountPreference) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountPreferences}/${accountPreference.accountID}/${accountPreference.preferenceID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountPreference) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addAccountPreference = (accountPreference) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountPreferences}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountPreference) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteAccountPreference = (accountId, preferenceId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountPreferences}/${accountId}/${preferenceId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//AccountUsers
export const getAccountUsers = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountUsers}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getAccountUser = (accountId, userId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountUsers}/${accountId}/${userId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const accountUser = await response.json();
                resolve(accountUser);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveAccountUser = (accountUser) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountUsers}/${accountUser.accountID}/${accountUser.userID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountUser) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addAccountUser = (accountUser) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountUsers}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(accountUser) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteAccountUser = (accountId, userId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.accountUsers}/${accountId}/${userId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//UserRoles
export const getUserRoles = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.userRoles}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getUserRole = (userId, roleId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.userRoles}/${userId}/${roleId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const userRole = await response.json();
                resolve(userRole);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveUserRole = (userRole) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.userRoles}/${userRole.userID}/${userRole.roleID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(userRole) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addUserRole = (userRole) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.userRoles}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(userRole) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteUserRole = (userId, roleId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.userRoles}/${userId}/${roleId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//Divisions
export const getDivisions = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.divisions}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getDivision = (divisionId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.divisions}/${divisionId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const preference = await response.json();
                resolve(preference);
            } else {
                if (response.status === 404) { //Not found
                    resolve(null);
                } else {
                    reject(response);
                }
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const saveDivision = (division) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.divisions}/${division.divisionID}`;
            const response = await fetch(url, {
                method: 'PUT', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(division) // body data type must match "Content-Type" header
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};

export const addDivision = (division) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.divisions}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(division) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteDivision = (divisionId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.divisions}/${divisionId}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            resolve(response.ok);
        } catch (err) {
            reject(err);
        }
    });
};


//PowerBI
export const getEmbedConfig = (options) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.powerBIReport}`;
            const response = await fetch(url + '?' + toQueryString(options), {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            if (response.ok) {
                const result = await response.json();
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
}


//Functions
export const processPayment = (paymentData) => {
    //paymentData.paymentInfo.sslEmail = 'warren.wegenke@state.sd.us'; //Temporary to get email from Converge
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.processPayment}`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(paymentData) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                const result = await response.json();
                console.log(result);
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
}
export const makePayment = async (accountId) => {
    console.log('Making payment: ' + accountId);
};

export const generateLetter = async (accountId) => {
    console.log('Sending Email Invoice: ' + accountId);
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.generateLetter}/${accountId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                resolve(blob);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const SendReceipt = async (PaymentID) => {
    console.log('Sending Receipt: ' + PaymentID);
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.receipt}/${PaymentID}`;
            const response = await fetch(url, {
                method: 'Get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
            });
            if (response.ok) {
                resolve(response);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const sendTestAccountInvoice = async (accountId, options) => {
    console.log('Sending Test Email Invoice');
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.sendTestEmail}/${accountId}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: options
            });
            if (response.ok) {
                resolve(response);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const sendTestInvoice = async (formData) => {
    console.log('Sending Test Email Invoice');
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.sendTestEmail}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: formData
            });
            if (response.ok) {
                resolve(response);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const GetInvoiceList = async (formData) => {
    console.log('Getting list of Invoices');
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.GetInvoiceList}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: formData
            });
            if (response.ok) {
                resolve(response);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const sendAccountInvoice = async (accountId, options) => {
    console.log('Sending Email Invoice: ' + accountId);
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.sendEmails}/${accountId}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: options
            });
            if (response.ok) {
                resolve(response);
            } else {
                //const result = await response.json();
                //console.log(result);
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const sendInvoices = async (formData) => {
    console.log('Sending Email Invoices');
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.sendEmails}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: formData
            });
            if (response.ok) {
                const result = await response.json();
                console.log(result);
                resolve(result);
            } else {
                //const result = await response.json();
                //console.log(result);
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const uploadFeesFile = (fileFormData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.upload}/fees`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: fileFormData // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const uploadAccountsFile = (fileFormData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.upload}/accounts`;
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: fileFormData // body data type must match "Content-Type" header
            });
            if (response.ok) {
                resolve(await response.json());
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const deleteFees = (deleteOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const url = `${window.env.api.baseUrl}${window.env.api.fees}`;
            const response = await fetch(url, {
                method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                },
                body: JSON.stringify(deleteOptions) // body data type must match "Content-Type" header
            });
            if (response.ok) {
                const result = await response.json();
                console.log(result);
                resolve(result);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};


//Caspio API
export const getCheckRegisters = (searchOptions) => {
    return new Promise(async (resolve, reject) => {
        try {
            const tokenUrl = `${window.env.api.baseUrl}${window.env.api.caspioToken}`;
            const responseToken = await fetch(tokenUrl, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            const token = await responseToken.json();

            const url = `${window.env.caspioApi.baseUrl}${window.env.caspioApi.checkRegister}`;
            const response = await fetch(url + '?' + toQueryString(searchOptions), {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': `Bearer ${token.access_token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.ok) {
                const result = await response.json();
                const checks = result.Result.map(check => {
                    check.CheckDate = new Date(check.CheckDate);
                    //addMinutesToDateTime(check.CheckDate, -check.CheckDate.getTimezoneOffset()); //Adjusting for timezone
                    check.RecdDate = new Date(check.RecdDate);
                    return check;
                });
                resolve(checks);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};

export const getCheckRegister = (checkId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const tokenUrl = `${window.env.api.baseUrl}${window.env.api.caspioToken}`;
            const responseToken = await fetch(tokenUrl, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + window.env.b2cToken.accessToken
                }
            });
            const token = await responseToken.json();

            const url = `${window.env.caspioApi.baseUrl}${window.env.caspioApi.checkRegister}`;
            const response = await fetch(url + '?q.where=PK_ID=' + checkId, {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': `Bearer ${token.access_token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (response.ok) {
                const result = await response.json();
                if (result.Result.length == 0)
                    resolve(null);

                const check = result.Result[0];
                check.CheckDate = new Date(check.CheckDate);
                check.RecdDate = new Date(check.RecdDate);

                resolve(check);
            } else {
                reject(response);
            }
        } catch (err) {
            reject(err);
        }
    });
};